import { Badge } from "@/components/ui/badge";

export default function SubscriptionBadge({ status, planName, className }) {
  const variantMap = {
    ACTIVE: "default",
    TRIAL: "secondary",
    PAST_DUE: "destructive",
    CANCELLED: "outline",
    EXPIRED: "outline",
  };

  const labelMap = {
    ACTIVE: "Active",
    TRIAL: "Trial",
    PAST_DUE: "Past Due",
    CANCELLED: "Cancelled",
    EXPIRED: "Expired",
  };

  return (
    <div className={`flex items-center gap-2 ${className || ""}`}>
      {planName && <span className="font-medium">{planName}</span>}
      {status && (
        <Badge variant={variantMap[status] || "outline"}>
          {labelMap[status] || status}
        </Badge>
      )}
    </div>
  );
}
